<template>
  <div class="home">
    <h1>Välkommen!</h1>
    <b-alert
        variant="warning"
        show
    >
        <div class="alert-body">
            <span>Startsidan är inte tillgänglig ännu. Här kommer du att hitta en översikt och genvägar till ditt innehåll i appen.</span>
        </div>
    </b-alert>

      <b-button @click="sendMail" variant="primary">Skicka ett test mail</b-button>
      <b-button @click="sendMailT" variant="primary">Skicka ett test mail fast i template form</b-button>
  </div>
</template>

<script>
//import { BCard, BCardText, BLink } from 'bootstrap-vue'
//import PageHeader from '@/layouts/components/PageHeader.vue'
import {BAlert} from 'bootstrap-vue'
import mailService from '@/services/mail.service.js';
import {
  BButton,
} from "bootstrap-vue";

export default {
  components: {
    BAlert,
    BButton
  },
  methods: {
    created(){
      const isDevEnv = process.env.NODE_ENV === 'development';
      if(!isDevEnv)
        this.$router.push("/error-404");
    },
    sendMail: function(){
        const substitutionFields = {
            First_Name: 'Rofarsvarfar',
            Last_Name: 'Svensson'
        };
        
      mailService.sendEmail("welcome", "andreas@bonigi.se", substitutionFields);
    },
    sendMailT: function(){
        const substitutionFields = {
            First_Name: 'Rofarsvarfar',
            Last_Name: 'Svensson'
        };

      mailService.sendEmail("welcome", "andreas@bonigi.se", substitutionFields);
    }
  }
}
</script>

<style>

</style>
